export default {
  id: 125,
  title: 'Target #125 - Root Learn',
  url: 'https://cssbattle.dev/play/125',
  colors: ['#EFF2F1', '#1C1C1C'],
  solution:
    '<a a><a b><a c><style>[a],body{background:#eff2f1}[b],[c]{background:#1c1c1c}a{position:fixed}[a]{top:75;left:130;width:90;height:60;border-radius:0 9in 9in 0;box-shadow:25px 0 0 15px #1c1c1c}[b]{top:60;left:110;width:80;height:180;clip-path:polygon(0 0,75% 0,75% 88.5%,100% 95%,100% 100%,0 100%,0 95%,25% 88.5%,25% 11.5%,0 5%)}[c]{top:135;left:170;width:120;height:105;clip-path:polygon(1% 0,51% 100%,100% 100%,100% 94%,80% 81%,39% 0)}</style>',
}
